import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon } from '@icons';
import cx from 'classnames';
import { nanoid } from 'nanoid';
import React, { useCallback, useMemo, useRef } from 'react';
import { isDark } from '../common/utils';
import { Menu } from '../menu/menu';
import styles from './menu-button.module.scss';
const MenuButton = ({ items = [], onSelected, focusable = true, width = 150, disabled = false, RTL = false, iconColor, size = 'sm', }) => {
    const menuItems = useRef(items.slice(1).map(item => ({
        id: nanoid(),
        name: item,
    })));
    const isDarkMode = useMemo(() => isDark(), []);
    const handleChange = useCallback((item) => {
        onSelected?.(item);
    }, []);
    const menuButtonClass = useMemo(() => cx(styles.wrapper, {
        [styles.disabled]: disabled,
        [styles.rtl]: RTL,
        [styles[size]]: true,
        [styles.dark]: isDarkMode,
    }), [disabled]);
    const menuPosition = useMemo(() => {
        return RTL ? 'left' : 'right';
    }, []);
    const menuStyle = useMemo(() => {
        return {
            '--icon-color': iconColor,
            '--max-width': `${width}px`,
        };
    }, []);
    const iconClass = useMemo(() => cx(styles.icon, {
        [styles.dark]: isDarkMode,
    }), []);
    const labelClass = useMemo(() => cx(styles.label, { [styles.dark]: isDarkMode }, styles[size]), []);
    return (_jsxs("div", { className: menuButtonClass, style: menuStyle, children: [_jsx("div", { role: "button", "aria-label": items[0], onClick: () => handleChange(items[0]), children: _jsx("label", { className: labelClass, children: items[0] }) }), _jsx(Menu, { items: menuItems.current, focusable: focusable, onSelected: handleChange, dockPosition: menuPosition, size: size, gutter: 15, hideArrow: true, leftOffset: 10 * (RTL ? -1 : 1), children: _jsx("span", { className: iconClass, role: "img", children: _jsx(ChevronDownIcon, {}) }) })] }));
};
MenuButton.displayName = 'MenuButton';
export { MenuButton };
